'use client';
import React, { useCallback, useEffect, useMemo } from 'react';
import { StyledAboutOverview } from '@/components/common/ygen/sections/about-overview/aboutoverview.style';
import { Col, Container, Row } from 'react-bootstrap';
import LeftSVGScroll from '@/components/common/ui/buttons/LeftSVGScroll';
import RightSVGScroll from '@/components/common/ui/buttons/RightSVGScroll';
import Title from '@/components/common/ui/text/Title';
import VideoTour from '@/components/common/ygen/sections/video-tour/VideoTour';
import reactHtmlParser from 'react-html-parser';
import useContainerOffset from '@/components/hooks/useContainerOffset';

const AboutOverview = ({ data }) => {
	const offset = useContainerOffset('.container');


	// Memoize the short description to prevent unnecessary re-renders
	const shortDesc = useMemo(
		() => data?.section_data?.short_desc,
		[data?.section_data?.short_desc],
	);

	// Memoize the description content to prevent unnecessary re-renders
	const descriptionContent = useMemo(
		() =>
			data?.section_data?.description &&
			reactHtmlParser(data?.section_data?.description),
		[data?.section_data?.description],
	);

	// Memoize the video tour link to prevent unnecessary re-renders
	const videoTourLink = useMemo(
		() => data?.section_data?.subtitle,
		[data?.section_data?.subtitle],
	);

	return (
		<StyledAboutOverview
			offset={offset}
			className="BlogList"
			data-scroll-section>
			<Container>
				<Row>
					<Col md={6}>
						{shortDesc && (
							<Title
								tag="h3"
								animClass="fade-up"
								margin="0 0 80px"
								text={shortDesc}
								color="#152637"
							/>
						)}

						<div className="content">{descriptionContent}</div>
					</Col>
					<Col md={{ span: 3, offset: 1 }}>
						<div
							className="video_tour"
							data-scroll
							data-scroll-direction="vertical"
							data-scroll-speed="4">
							<VideoTour link={videoTourLink} />
						</div>
					</Col>
				</Row>
			</Container>

			<LeftSVGScroll about />
			<RightSVGScroll about />
		</StyledAboutOverview>
	);
};



export default React.memo(AboutOverview);
